import { render, staticRenderFns } from "./son.vue?vue&type=template&id=de10950a&scoped=true&"
import script from "./son.vue?vue&type=script&lang=js&"
export * from "./son.vue?vue&type=script&lang=js&"
import style0 from "./son.vue?vue&type=style&index=0&id=de10950a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de10950a",
  null
  
)

export default component.exports